"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxStyles = void 0;
var core_1 = require("@material-ui/core");
var _colors_1 = require("../../../style/_colors");
exports.CheckboxStyles = core_1.makeStyles(function () { return ({
    formControlLabel: {
        color: _colors_1.darkBlue,
        height: 24,
        borderColor: 'red',
        '& a': {
            fontWeight: 500,
            color: _colors_1.darkBlue,
        },
    },
    checkbox: {
        height: 42,
        width: 42,
        color: _colors_1.darkBlue,
        borderColor: 'red',
        padding: 0,
        '&:hover': {
            backgroundColor: _colors_1.lightBlue,
        },
    },
    checkboxChecked: {
        borderColor: 'red',
        color: _colors_1.darkBlue,
        '&:hover': {
            backgroundColor: _colors_1.lightBlue + " !important",
        },
    },
    checkboxLabel: {
        fontFamily: 'Roboto',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontSize: function (props) { return props.fontSize; },
        lineHeight: 'normal',
        letterSpacing: 'normal',
    },
    checkboxErrorMessage: {
        marginLeft: '32px !important',
        marginTop: '0',
        fontFamily: 'Roboto',
        fontSize: 12,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.21,
        letterSpacing: 'normal',
    },
}); });
